export default "/assets/images/mila-feed-11-thumbnail.baf3ee68781a16df.jpg";